import axios from "axios";
import router from "@/router/index"; // Asegúrate de importar Vue Router si usas Vue Router

const api = axios.create();

// Interceptor para agregar el token de autenticación a cada solicitud
api.interceptors.request.use(
  config => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  response => response, // Si la respuesta es correcta, la retornamos
  error => {
    if (error.response && error.response.status === 401) {
      console.warn("Sesión expirada. Redirigiendo a login...");
      
      // Eliminar el token almacenado si es necesario
      localStorage.removeItem("token");

      // Redirigir a la página de login
      const currentRoute = router.currentRoute.value;
      const projectId = currentRoute.params.projectId;
      console.log('test rutaa:', currentRoute);

      if (projectId) {
        router.push(`/p/${projectId}/login`).catch(() => {}); // Evita errores si ya estás en login del proyecto
      } else {
        router.push("/login").catch(() => {}); // Redirige al login general
      }
    }

    return Promise.reject(error); // Rechaza el error para que lo manejen los llamados a Axios
  }
);

export default api;
